import { CSSProperties } from 'react';
import { BannerTileStoryblok } from 'storyblok-types';
import { IYoutube } from 'modules/media/hooks';
import { MediaQuery } from 'modules/mui/hooks';

export interface IConfig {
  classes?: string;
  showName?: boolean;
  url?: string;
  buttonText?: string;
  css?: CSSProperties;
}

export interface ITile {
  blok: BannerTileStoryblok;
  config: IConfig;
  deviceType?: MediaQuery['type'];
}

export interface IVideoTile {
  blok: BannerTileStoryblok;
  config: IConfig;
  videoData?: IYoutube | null;
}

export enum TileTypes {
  PROMOTION = 'promotion',
  VIDEO = 'video',
  TOPIC = 'topic',
  TRUST = 'trust',
  IMAGE = 'image',
  LISTICLE = 'listicle',
  LANDING = 'landing',
  BRAND = 'brand',
}

export type IsTitleExist = (data: BannerTileStoryblok['title']) => Boolean;
